import { render, staticRenderFns } from "./infoView.vue?vue&type=template&id=81254832&scoped=true&"
import script from "./infoView.vue?vue&type=script&lang=js&"
export * from "./infoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81254832",
  null
  
)

export default component.exports